<template>
  <v-container fluid fill-height>
    <v-layout row wrap max>
      <v-flex xs12 text-xs-center v-if="programClosed">
        <div class="container" style="background-color: #fff; border: 1px solid red; padding: 12px !important; width: 100%; max-width: 700px; margin: 12px auto;">
          <p>
            Уважаемые участники! С 1 октября 2026 года программа мотивации «Ricoh Club» приостановлена, доступ в личный кабинет недоступен. Следите за обновлениями!
          </p>
        </div>
      </v-flex>
      <v-flex xs12 text-xs-center v-else-if="this.$store.state.settings.extranet !== true">
        <h2>Добро пожаловать!</h2>
        <v-flex text-xs-center mt-3>
          <v-btn to="/login">Войти</v-btn>
          <v-btn color="primary" to="/register">Регистрация</v-btn>
        </v-flex>
        <v-btn to="/remind">Забыли пароль</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import programClosed from '../../programClosed';

  export default {
    data() {
      return { programClosed };
    },
  };
</script>
